import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChurchIcon(props: IconProps) {
    return <Icon {...props} iconKey={"church"}/>
}
